<script>
export default {
  methods: {
    attributeName(attributes, key) {
      if (attributes) {
        const item = attributes.find((attributeItem) => attributeItem.AttributeKey === key);

        if (item) {
          return item.AttributeName;
        }
      }

      return null;
    },
    attributeValue(attributes, key) {
      if (attributes) {
        const item = attributes.find((attributeItem) => attributeItem.AttributeKey === key);

        if (item) {
          return item.Value;
        }
      }

      return null;
    },
    attributeUnit(attributes, key) {
      if (attributes) {
        const item = attributes.find((attributeItem) => attributeItem.AttributeKey === key);

        if (item) {
          return item.Unit;
        }
      }

      return null;
    },
  },
};
</script>
